import SaveAndBackButton, { SaveState } from 'app/shared/ui/GenericSaveAndBackButton';
import { Alert } from 'antd';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action} from 'app/pages/AgentPricing/actionTypes';
import { saveAgentCommissionRates } from 'app/pages/AgentPricing/commands';
import { getAgentId, getAgentGroupId, getIsAgentCommissionBlocked } from 'app/pages/AgentPricing/modules/RefData';
import { getSaveStatus, getHasSaveError, getValidationMessage } from 'app/pages/AgentPricing/modules/SaveStatus';

interface EditButtonPanelProps {

}

interface StateProps {
    backUrl: string
    saveState: SaveState
    hasError: boolean
    isAgentStopped: boolean
    validationMessage: string | null
}

interface DispatchProps {
    onSaveClicked: () => void
}

type InternalProps = StateProps&DispatchProps;

function EditButtonPanel(props: InternalProps) {
    return <>
        <SaveAndBackButton 
            onSaveClicked={props.onSaveClicked} 
            saveState={props.isAgentStopped ? SaveState.NoChanges : props.saveState}
            backUrl={props.backUrl}
            statusMessage={props.validationMessage ?? undefined}
            statusMessageTone={props.validationMessage ? 'error' : undefined}
        />
            {props.hasError &&
                <div style={{ marginTop: 16 }}>
                    <Alert
                        title="Unable to save record"
                        description="If the problem persists then please contact support"
                        type="error"
                        showIcon
                    />
                </div>
            }
        </>;
}

function mapStateToProps(state: any, ownProps: EditButtonPanelProps) : StateProps {
    const groupId = getAgentGroupId(state);
    const scopeId = groupId ?? getAgentId(state);
    return {
        backUrl: '/agents/rates?id=' + encodeURIComponent(scopeId),
        saveState: getSaveStatus(state),
        hasError: getHasSaveError(state),
        isAgentStopped: getIsAgentCommissionBlocked(state),
        validationMessage: getValidationMessage(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<any, any, Action>) : DispatchProps {
    return {
        onSaveClicked: () => dispatch(saveAgentCommissionRates())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditButtonPanel);